$(document).ready(function () {
    if ($('#featured-article-carousel').length > 0) {
        var featured_article_carousel = tns({
            container: "#featured-article-carousel .featured-article-slider",
            items: 5,
            slideBy: 'page',
            autoplay: false,
            loop: true,
            mouseDrag: true,
            lazyload: false,
            controlsContainer: "#featured-article-carousel .featured-article-slider-controls"
        });
    }
});